/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, arrayOf } from 'prop-types';
import { useUIDSeed } from 'react-uid';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import style from './FourUpVariantA.module.css';
import MessageStandard from '../../../../SubComponents/Message/MessageStandard';
import universalHandleClick from '../../../../UniversalHandleClick';
import normalizeAltCopy from '../../../../../../../helpers/normalizeAltCopy';

const FourUpVariantA = ({
    data, gaConstants, salesforceResponse,
}) => {
    useStyles(style);
    const seed = useUIDSeed();
    const ctaStyle = data?.cta_presentation?.presentation_variant;
    const defaultParams = 'auto=webp';
    if (data.tile.length) {
        const handleClick = universalHandleClick(salesforceResponse);
        return (
            <div className={style.container} data-testid="FourUpVariantA">
                {
                    data.tile.map(({
                        image = {},  cta = {}, message = {}, styled_button,
                    }) => (
                        <div
                            key={seed(image)}
                            className={`${style.imageWrapper} ${!cta?.link?.href && !cta?.link?.title ? style.disableClick : ''}`}
                            role="presentation"
                            onClick={() => handleClick(cta, gaConstants)}
                            data-ga-category={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-ga-action={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-ga-label={cta?.tracking_event_label || gaConstants?.tracking_event_label}

                            data-banner-item-name={cta?.tracking_event_label || gaConstants?.tracking_event_label}
                            data-banner-type={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-banner-group={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-click-id="FourUpVariantA"
                            data-click-text="FourUpVariantA"
                        >
                            <img className={style.image} src={`${image?.url}?${defaultParams}`} alt={normalizeAltCopy(image.description || image.title || 'decorative image')} />
                            <div className={style.messageBlock}>
                                <MessageStandard
                                    data={{
                                        content: message.content,
                                        heading: message.heading,
                                        sub_heading: message.sub_heading,
                                        message_position: {},
                                        styled_button,
                                        cta: {
                                            link: cta.link,
                                            theme: cta.theme,
                                            presentation: ctaStyle,
                                            tracking_event_category: gaConstants.tracking_event_category,
                                            tracking_event_action: gaConstants.tracking_event_action,
                                            tracking_event_label: cta.tracking_event_label,
                                        },
                                        has_background: false,
                                    }}
                                />
                            </div>
                        </div>
                    ),
                    )
                }
            </div>
        );
    }

    return mbpLogger.logError({
        appName: process.env.npm_package_name,
        component: 'Tiles/4upStandard/FourUpVariantA/FourUpVariantA.js',
        message: 'No data available to render component',
    });
};

FourUpVariantA.propTypes = {
    data: arrayOf.isRequired,
    gaConstants: object.isRequired,
    salesforceResponse: object,
};
FourUpVariantA.defaultProps = {
    salesforceResponse: {},
};

export default FourUpVariantA;
